/**
 * Gets index ofitem from array
 * @export
 * @param {array} array -The array of cart items
 * @param {object} item -  to search for
 * @param {boolean} isPack - check if item is pack
 * @returns {Number} Return index value of item from array
 */
export default function getIndexForItem(array, item, isPack) {
	let index = -1;

	if (isPack) {
		index = array.findIndex(
			cartItem =>
				cartItem.pack_id === item.pack_id &&
				(cartItem.initial_drop_ship_address && item.initial_drop_ship_address
					? cartItem.initial_drop_ship_address.name ===
						item.initial_drop_ship_address.name
					: cartItem.initial_drop_ship_address ===
						item.initial_drop_ship_address)
		);
	} else {
		index = array.findIndex(
			cartItem =>
				cartItem.id === item.id &&
				(cartItem.initial_drop_ship_address && item.initial_drop_ship_address
					? cartItem.initial_drop_ship_address.name ===
						item.initial_drop_ship_address.name
					: cartItem.initial_drop_ship_address ===
						item.initial_drop_ship_address)
		);
	}

	return index;
}



// WEBPACK FOOTER //
// ./src/state/helpers/itemIndexSearch/index.js